import React from 'react';
import { WIZARD_TREE, getWizardRoot } from '../data/wizard';
import { SECTIONS } from '../data/sections';
import './WizardZone.css';

export default function WizardZone({ state, onWizSelect, onWizBack, onWizReset, onOpenSection }) {
  const { wizNode = 'root', wizPath = [], wizResult } = state;
  const node = (!wizNode || wizNode === 'root')
    ? getWizardRoot(state.role)
    : WIZARD_TREE[wizNode];
  const hasBack = wizPath && wizPath.length > 0;

  const handleSelect = (opt) => {
    if (opt.result) {
      onWizSelect(null, opt.result);
    } else {
      onWizSelect(opt.next, null);
    }
  };

  return (
    <div className="wizard-zone">
      <div className="wizard-header">
        <i className="ti ti-map-2" style={{ fontSize: 20, color: '#fff' }} aria-hidden="true" />
        <div>
          <div className="wizard-header-title">Where are you right now?</div>
          <div className="wizard-header-sub">Tell me your current situation and I'll guide you to what's next</div>
        </div>
      </div>

      <div className="wizard-body">
        {wizResult ? (
          <WizardResult
            result={wizResult}
            hasBack={hasBack}
            onBack={onWizBack}
            onReset={onWizReset}
            onOpen={onOpenSection}
          />
        ) : node ? (
          <WizardQuestion
            node={node}
            hasBack={hasBack}
            onSelect={handleSelect}
            onBack={onWizBack}
          />
        ) : null}
      </div>
    </div>
  );
}

function WizardQuestion({ node, hasBack, onSelect, onBack }) {
  return (
    <>
      {hasBack && (
        <button className="wizard-back-btn" onClick={onBack}>
          <i className="ti ti-arrow-left" style={{ fontSize: 11 }} aria-hidden="true" />
          Go back
        </button>
      )}
      <div className="wizard-q">{node.q}</div>
      <div className="wizard-opts">
        {node.opts.map((opt, i) => (
          <div key={i} className="wizard-opt" onClick={() => onSelect(opt)}>
            <div className="wizard-opt-icon">
              <i className={`ti ${opt.icon}`} style={{ fontSize: 16, color: '#1F4E79' }} aria-hidden="true" />
            </div>
            <div className="wizard-opt-body">
              <div className="wizard-opt-title">{opt.label}</div>
              <div className="wizard-opt-sub">{opt.sub}</div>
            </div>
            <i className="ti ti-chevron-right" style={{ fontSize: 13, color: '#9E9E9E', flexShrink: 0 }} aria-hidden="true" />
          </div>
        ))}
      </div>
    </>
  );
}

function WizardResult({ result, hasBack, onBack, onReset, onOpen }) {
  const sec = SECTIONS[result.section];
  const preview = sec?.checklist?.slice(0, 4) || [];
  const remaining = (sec?.checklist?.length || 0) - preview.length;

  return (
    <>
      {hasBack && (
        <button className="wizard-back-btn" onClick={onBack}>
          <i className="ti ti-arrow-left" style={{ fontSize: 11 }} aria-hidden="true" />
          Ask again
        </button>
      )}

      <div className="wizard-result-tag">
        <i className="ti ti-map-pin" style={{ fontSize: 10 }} aria-hidden="true" />
        Recommended next action
      </div>

      <div className="wizard-result-card">
        <div className="wizard-result-section">{result.section} — {sec?.title}</div>
        <div className="wizard-result-tip">{result.tip}</div>
      </div>

      {preview.length > 0 && (
        <div className="wizard-preview">
          <div className="wizard-preview-label">First steps in this section:</div>
          {preview.map(([step], i) => (
            <div key={i} className="wizard-preview-step">
              <i className="ti ti-circle-dashed" style={{ fontSize: 12, color: '#2E75B6', flexShrink: 0 }} aria-hidden="true" />
              <span>{step}</span>
            </div>
          ))}
          {remaining > 0 && (
            <div className="wizard-preview-step" style={{ color: '#9E9E9E' }}>
              <i className="ti ti-dots" style={{ fontSize: 12, flexShrink: 0 }} aria-hidden="true" />
              <span>+{remaining} more steps</span>
            </div>
          )}
        </div>
      )}

      <div className="wizard-result-actions">
        <button className="btn btn-primary" onClick={() => onOpen(result.section)}>
          <i className="ti ti-arrow-right" aria-hidden="true" />
          Open checklist
        </button>
        <button className="btn" onClick={onReset}>
          <i className="ti ti-refresh" aria-hidden="true" />
          Start over
        </button>
      </div>
    </>
  );
}
